import React from 'react';

/**
 * Stimmkurve – Icon fuer die Agenten-Seite.
 *
 * Fuenf Balken in Wellenform: der Agent spricht. Bewusst kein Telefonhoerer,
 * weil der Agent auch per WhatsApp schreibt und der Hoerer im Dashboard
 * bereits fuer den Telefon-Tab belegt ist.
 *
 * 24er-Raster, Strichstaerke und runde Enden passen zum Lucide-Stil der
 * uebrigen Navigation.
 */
export const VoiceWaveIcon = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    <path d="M3 11v2" />
    <path d="M7 8.5v7" />
    <path d="M11 5v14" />
    <path d="M15 8v8" />
    <path d="M19 10.5v3" />
  </svg>
);

export default VoiceWaveIcon;
